/**
 * Düğün tarihi formatlama — worker (SMS dispatch/preview/onay) ve guest app
 * ortak kullanır. Önceden iki ayrı kopya vardı (`home.tsx` locale-duyarlı,
 * `sms-dispatch.ts` tr-TR sabit) ve iki yer hiç formatlamadan ham `date_time`
 * basıyordu; hepsi buraya bağlandı.
 *
 * ⚠️ `weddings.date_time` / `event2_date_time` TZ taşımaz (`datetime-local`
 * ham string, örn. `"2026-08-16T19:00"`) — `new Date()` onu ÇALIŞTIĞI ORTAMIN
 * yerel saatinde yorumlar. Bu mevcut bir borç; burada değiştirilmiyor.
 */

const dtfCache = new Map<string, Intl.DateTimeFormat>();

/** Varsayılan: gün + ay adı + yıl (SMS'in bugünkü davranışıyla birebir aynı). */
export const WEDDING_DATE_SHORT: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "long",
  year: "numeric",
};

/** Ana sayfa kartı: hafta günü + tam tarih + saat. */
export const WEDDING_DATE_LONG: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

export function formatWeddingDate(
  dateTime: string | null | undefined,
  locale = "tr-TR",
  opts: Intl.DateTimeFormatOptions = WEDDING_DATE_SHORT,
): string {
  if (!dateTime) return "";
  const d = new Date(dateTime);
  if (Number.isNaN(d.getTime())) return dateTime;
  try {
    const key = `${locale}|${JSON.stringify(opts)}`;
    let dtf = dtfCache.get(key);
    if (!dtf) {
      dtf = new Intl.DateTimeFormat(locale, opts);
      dtfCache.set(key, dtf);
    }
    return dtf.format(d);
  } catch {
    return dateTime;
  }
}

/** Yalnız hafta günü (`Cumartesi`) — program satırlarında saatten ayrı durur. */
export function formatWeddingWeekday(
  dateTime: string | null | undefined,
  locale = "tr-TR",
): string {
  if (!dateTime) return "";
  const d = new Date(dateTime);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return d.toLocaleDateString(locale, { weekday: "long" });
  } catch {
    return "";
  }
}

/** Yalnız saat (`19:00`) — tema/venue bölümlerinde tarihten ayrı gösterilir. */
export function formatWeddingTime(
  dateTime: string | null | undefined,
  locale = "tr-TR",
): string {
  if (!dateTime) return "";
  const d = new Date(dateTime);
  if (Number.isNaN(d.getTime())) return "";
  try {
    return d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}
